/**
 * Created by Mark on 18/04/2017.
 */

import TranslationServices from '../../services/translation-service.js';
import TranslationStore from '../../store/translation-store.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import '../../css/muilt-select.css';
import Select from  'react-select';

export default class AllLanguageSelector extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {languages:[] , value :props.value || null, disabled:props.disabled || null, disableAll:props.disableAll || null}
        this.onSelect = this.onSelect.bind(this)
    }

    componentDidMount() {
        TranslationServices.getAllLanguages()
    }

    componentWillMount(){

        if (this.state.languages.length > 0){
            if(!this.state.value)this.onSelect({value:this.state.languages[0].ietf , label: this.state.languages[0].text  })
        }
        
        if(this.state.languages.length > 2 ) return;
        

        TranslationStore.on("CHANGE" , () => {
            
            let languages = TranslationStore.languages || [];

            var sorted  = this.sortLanguages(languages);
            if (sorted.length > 0 && sorted[0].ietf != "All" && !this.state.disableAll){
                sorted.unshift({ietf:"All", text:"All"});
            } 

            if (sorted.length > 0 && sorted[1].ietf == 'en'){
                this.setState({languages:sorted});
            } 

            if (sorted.length > 0){
                if(!this.state.value)this.onSelect({value:sorted[0].ietf , label: sorted[0].text  })
            }
        });
    }

    sortLanguages(languages){
        if (languages == undefined) return [];
        var priority = ["English", "US English", "German", "Dutch", "Swedish", "Latin American Spanish", "French"];
  


        var sortedLanguages = [];
        for (var i = 0; i < languages.length; i++) {
            if (languages[i].ietf == 'en') {
                sortedLanguages.push(languages[i]);
                languages.splice(i, 1);
            }
        }
        sortedLanguages.push({ietf:'en', text:'English'});

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "US English") {
                languages.splice(i, 1);
            }
        }
        sortedLanguages.push({ietf:'en-US', text:'U.S. English'});

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "German") {
                languages.splice(i, 1);
            }
        }
        sortedLanguages.push({ietf:'de', text:'German'});

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "Dutch") {
                languages.splice(i, 1);
            }
        }
        sortedLanguages.push({ietf:'nl', text:'Dutch'});

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "Swedish") {
                languages.splice(i, 1);
            }
        }
        sortedLanguages.push({ietf:'sv', text:'Swedish'});

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "Latin American Spanish") {
                languages.splice(i, 1);
            }
        }
        sortedLanguages.push({ietf:'es-MX', text:'Latin American Spanish'});

        for (var i = 0; i < languages.length; i++) {
            if (languages[i].text == "French") {
                languages.splice(i, 1);
            }
        }
        sortedLanguages.push({ietf:'fr', text:'French'});

        for (var i = 0; i < languages.length; i++) {
            sortedLanguages.push(languages[i]);
        }


        return sortedLanguages;

    }

    onSelect(option) {

        if (this.props.onSelect)
            if (option.value == "All") {
                this.props.onSelect({ ietf: "All" });
            } else if (!this.props.multi) this.props.onSelect({ietf: option.value});
            else {
                console.log("here");
                this.props.onSelect(option);
            }

        this.setState({ value: option });
    }

    render(){
        if (this.state.disabled != null && this.state.disabled != undefined) {
            for (var i = 0; i < this.state.disabled.length; i++){
                for (var j = 0; j < this.state.languages.length; j++){
                    if (this.state.languages[j].ietf == this.state.disabled[i]){
                        this.state.languages.splice(j, 1);
                    }
                }
            }
        }

        const options = this.state.languages.map(function(language){
             return  { value: language.ietf, label: language.text}
        });

        return <Select multi={this.props.multi} disabled={false} onChange={this.onSelect} className={this.props.className} 
                value={this.state.value} options={options} noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>}
                placeholder={<FormattedMessage id={ 'ui-892' } defaultMessage={ 'Select' }/>}/>
    }

}



// WEBPACK FOOTER //
// ./src/components/inputs/all-language-selector.js